import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface Props {
  show: boolean;
  title: string;
  subtitle?: string;
  onHide: () => void;
  children: React.ReactNode;
}

const CalendarAgendaEmailModal: React.FC<Props> = ({ show, title, subtitle, onHide, children }) => (
  <Modal show={show} onHide={onHide} size="lg" backdrop="static" scrollable centered>
    <Modal.Header closeButton>
      <div>
        <Modal.Title>{title}</Modal.Title>
        {subtitle ? <div className="small text-muted mt-1">{subtitle}</div> : null}
      </div>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" size="sm" onClick={onHide}>
        Fechar
      </Button>
    </Modal.Footer>
  </Modal>
);

export default CalendarAgendaEmailModal;
